module.exports = require("./eu.d.ts");